import type {
  AccountMembershipResponse,
  ChangePrimaryInstanceRequest,
  DemoteSuperAdminRequest,
  FileResponse,
  PromoteSuperAdminRequest,
  SuperAdminResponse,
  TransferPrimaryRequest,
} from 'src/api/ProactApiClient';
import {userInstanceApiClient} from 'src/api/ProactApiClientInstances';
import {emptySplitApi} from '../api';
import {clientQuery} from '../clientQuery';

export const userInstanceApi = emptySplitApi.injectEndpoints({
  endpoints: builder => ({
    getAccountMemberships: builder.query<AccountMembershipResponse[], number>({
      queryFn: clientQuery(accountId =>
        userInstanceApiClient.getAccountMemberships(accountId)
      ),
      providesTags: ['Users'],
    }),
    transferPrimary: builder.mutation<
      FileResponse | null,
      TransferPrimaryRequest
    >({
      queryFn: clientQuery(request =>
        userInstanceApiClient.transferPrimary(request)
      ),
      invalidatesTags: ['Users'],
    }),
    getSuperAdmins: builder.query<SuperAdminResponse[], void>({
      queryFn: clientQuery(() => userInstanceApiClient.listSuperAdmins()),
      providesTags: ['Users'],
    }),
    promoteSuperAdmin: builder.mutation<
      SuperAdminResponse,
      PromoteSuperAdminRequest
    >({
      queryFn: clientQuery(request =>
        userInstanceApiClient.promoteSuperAdmin(request)
      ),
      invalidatesTags: ['Users'],
    }),
    demoteSuperAdmin: builder.mutation<
      FileResponse | null,
      DemoteSuperAdminRequest
    >({
      queryFn: clientQuery(request =>
        userInstanceApiClient.demoteSuperAdmin(request)
      ),
      invalidatesTags: ['Users'],
    }),
    changePrimaryInstance: builder.mutation<
      SuperAdminResponse,
      ChangePrimaryInstanceRequest
    >({
      queryFn: clientQuery(request =>
        userInstanceApiClient.changePrimaryInstance(request)
      ),
      invalidatesTags: ['Users'],
    }),
  }),
});

export const {
  useGetAccountMembershipsQuery,
  useTransferPrimaryMutation,
  useGetSuperAdminsQuery,
  usePromoteSuperAdminMutation,
  useDemoteSuperAdminMutation,
  useChangePrimaryInstanceMutation,
} = userInstanceApi;
